const initialState = []

export const majorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'majors/setAll':
      return action.payload
  
    default:
      return state
  }
}